module.exports = __webpack_public_path__ + "static/media/ex20.78944874.jpg";